import React from 'react';

const TermosDeUso: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-900 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white dark:bg-slate-800 rounded-lg shadow-md p-8 md:p-12">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Termos de Uso</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">Ultima atualizacao: 15 de julho de 2026</p>

        <div className="prose prose-gray dark:prose-invert max-w-none space-y-6 text-gray-700 dark:text-gray-300">

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">1. Aceitacao dos Termos</h2>
            <p>
              Ao acessar ou utilizar a plataforma SinTicket ("servico"), voce concorda com estes Termos de Uso.
              Se nao concordar com algum dos termos, nao utilize o servico.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">2. Descricao do Servico</h2>
            <p>
              A SinTicket e uma plataforma SaaS (Software como Servico) de gestao de atendimento omnichannel
              que permite empresas gerenciar comunicacoes com clientes atraves de WhatsApp, Instagram,
              Facebook Messenger e outros canais, de forma integrada. O servico inclui:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Gestao de atendimento e tickets</li>
              <li>Integracao com WhatsApp Business API (via provedores autorizados)</li>
              <li>Automacao de mensagens e respostas rapidas</li>
              <li>Gestao de contatos e campanhas</li>
              <li>Relatorios e metricas de atendimento</li>
              <li>Gerenciamento de usuarios e permissoes</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">3. Cadastro e Conta</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Voce deve fornecer informacoes verdadeiras, completas e atualizadas durante o cadastro.</li>
              <li>Voce e responsavel pela seguranca de suas credenciais de acesso.</li>
              <li>Voce e responsavel por todas as atividades realizadas em sua conta.</li>
              <li>Notifique-nos imediatamente sobre qualquer uso nao autorizado de sua conta.</li>
              <li>Uma pessoa juridica deve designar um representante autorizado para gerenciar a conta.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">4. Uso Aceitavel</h2>
            <p>Ao utilizar o servico, voce concorda em NAO:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Enviar spam, mensagens em massa nao autorizadas ou conteudo nao solicitado.</li>
              <li>Violar as politicas de uso do WhatsApp Business ou da Meta Platforms.</li>
              <li>Enviar conteudo ilegal, difamatorio, obsceno, ameacador ou que viole direitos de terceiros.</li>
              <li>Tentar acessar contas de outros usuarios sem autorizacao.</li>
              <li>Interromper ou sobrecarregar a infraestrutura do servico.</li>
              <li>Realizar engenharia reversa, descompilar ou desmontar qualquer componente do servico.</li>
              <li>Utilizar o servico para fins fraudulentos ou enganosos.</li>
              <li>Violar direitos de propriedade intelectual.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">5. Propriedade Intelectual</h2>
            <p>
              Todo o conteudo, codigo-fonte, design, marcas registradas e materiais do servico sao de
              propriedade da SinTicket ou de seus licenciadores e sao protegidos por leis de propriedade
              intelectual. Nenhuma licenca ou direito e concedido exceto o direito limitado de utilizar
              o servico conforme estes Termos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">6. Dados e Conteudo do Usuario</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Voce mantem a propriedade de todos os dados e conteudo que envia ao servico.</li>
              <li>Voce nos concede uma licenca limitada para processar seus dados exclusivamente para fornecer o servico.</li>
              <li>Voce e responsavel pelo conteudo das mensagens enviadas atraves da plataforma.</li>
              <li>Voce garante que tem o direito legal de processar os dados pessoais dos seus contatos.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">7. Disponibilidade e Suporte</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Empenhamo-nos em manter disponibilidade alta, mas nao garantimos 100% de uptime.</li>
              <li>Manutencoes programadas serao comunicadas com antecedencia minima de 24h.</li>
              <li>Suporte tecnico e disponibilizado conforme o plano contratado.</li>
              <li>Nos reservamos o direito de suspender contas que violem estes Termos.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">8. Precos e Pagamento</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Os precos sao informados na pagina de planos e podem ser alterados mediante aviso previo de 30 dias.</li>
              <li>Pagamentos sao processados mensalmente ou anualmente, conforme o plano escolhido.</li>
              <li>A nao pagamento resultara na suspensao apos periodo de carencia de 7 dias.</li>
              <li>Reembolsos sao analisados caso a caso dentro de 14 dias apos a contratacao.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">9. Limitacao de Responsabilidade</h2>
            <p>
              O servico e fornecido "como esta". Na maxima extensao permitida por lei, a SinTicket nao
              se responsabiliza por danos indiretos, incidentais, especiais, consequenciais ou punitivos,
              incluindo perda de dados, lucros cessantes ou interrupcao de negócios.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">10. Indenizacao</h2>
            <p>
              Voce concorda em indenizar e isentar a SinTicket de quaisquer reclamacoes, danos, perdas,
              responsabilidades e despesas decorrentes de seu uso do servico ou violacao destes Termos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">11. Rescisao</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Voce pode encerrar sua conta a qualquer momento atraves das configuracoes.</li>
              <li>Nos podemos suspender ou encerrar sua conta mediante violacao destes Termos.</li>
              <li>Apos o encerramento, seus dados serao tratados conforme nossa Politica de Privacidade.</li>
              <li>Disposicoes que por sua natureza devem permanecer em vigor apos a rescisao permanecerao aplicaveis.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">12. Lei Aplicavel e Foro</h2>
            <p>
              Estes Termos sao regidos pelas leis da Republica Federativa do Brasil. Fica eleito o foro
              da Comarca de Campinas para dirimir quaisquer questões oriundas destes Termos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">13. Alteracoes</h2>
            <p>
              Reservamo-nos o direito de alterar estes Termos a qualquer momento. Alteracoes significativas
              serao comunicadas com antecedencia minima de 15 dias. O uso continuado do servico apos as
              alteracoes constitui aceitacao.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">14. Contato</h2>
            <p>
              Em caso de duvidas sobre estes Termos:<br />
              Email: suporte@sinticket.com.br
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default TermosDeUso;
